// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!./about.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/css-loader/dist/cjs.js!./general.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../node_modules/css-loader/dist/cjs.js!./menu.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Playwrite NZ Basic";
  font-style: normal;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/playwritenzbasic/v1/YcmrsYdNS1SdgmHbGgtRtk4ljD2L-0ttuA.woff2)
    format("woff2");
}

button {
  border: none;
  background-color: #4b2e1e;
  padding:0.5rem 1.1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 1.2rem;
  color: #fff;
  cursor: pointer;
  transition: 0.4s;
  font-size: 1rem;
}

button:hover {
  background-color: #e9e4e2;
  color: #4b2e1e;
}
#content {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100%;
  width: 100%;
}



.nav-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  padding-top: 1rem;
}

.header {
  top: 0;
  z-index: 3;
  position: fixed;
  width: 100vw;
  display: flex;
  max-height: 150px;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  padding: 0.5rem;
  background-color: rgba(224, 208, 199, 0.4);
}

.res-name {
  display: flex;
  justify-content: center;
  align-items: center;
}
.res-name p {
  font-size: 3rem;
  font-weight: bold;
  font-family: "Playwrite NZ Basic";
  color: #4b2e1e;
}

.image-overlay {
  height: 100%;
  width: 100%;
  position: relative;
}
.image-overlay img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.image-overlay::after {
  content: "";
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
}

.hero-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 1.4rem;
  position: absolute;
  top: 55%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  text-align: center;
  max-width: 700px;
  gap: 15px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/index.css"],"names":[],"mappings":"AAIA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,kBAAkB;EAClB;mBACiB;AACnB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,WAAW;AACb;;;;AAIA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,MAAM;EACN,UAAU;EACV,eAAe;EACf,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;AACX","sourcesContent":["@import url(\"./about.css\");\n@import url(\"./general.css\");\n@import \"./menu.css\";\n@import \"./general.css\";\n@font-face {\n  font-family: \"Playwrite NZ Basic\";\n  font-style: normal;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/playwritenzbasic/v1/YcmrsYdNS1SdgmHbGgtRtk4ljD2L-0ttuA.woff2)\n    format(\"woff2\");\n}\n\nbutton {\n  border: none;\n  background-color: #4b2e1e;\n  padding:0.5rem 1.1rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 1.2rem;\n  color: #fff;\n  cursor: pointer;\n  transition: 0.4s;\n  font-size: 1rem;\n}\n\nbutton:hover {\n  background-color: #e9e4e2;\n  color: #4b2e1e;\n}\n#content {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  height: 100%;\n  width: 100%;\n}\n\n\n\n.nav-bar {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 1rem;\n  padding-top: 1rem;\n}\n\n.header {\n  top: 0;\n  z-index: 3;\n  position: fixed;\n  width: 100vw;\n  display: flex;\n  max-height: 150px;\n  justify-content: space-around;\n  align-items: center;\n  flex-wrap: wrap;\n  padding: 0.5rem;\n  background-color: rgba(224, 208, 199, 0.4);\n}\n\n.res-name {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.res-name p {\n  font-size: 3rem;\n  font-weight: bold;\n  font-family: \"Playwrite NZ Basic\";\n  color: #4b2e1e;\n}\n\n.image-overlay {\n  height: 100%;\n  width: 100%;\n  position: relative;\n}\n.image-overlay img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.image-overlay::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.45);\n}\n\n.hero-text {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  font-size: 1.4rem;\n  position: absolute;\n  top: 55%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  color: white;\n  text-align: center;\n  max-width: 700px;\n  gap: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
